import script from "./chartjs.vue?vue&type=script&lang=js"
export * from "./chartjs.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__